module.exports = __webpack_public_path__ + "static/tagline-0b427af3a16163ec90161a9031a86ca9.png";